import { createFileRoute } from "@tanstack/react-router";

import { AcceptInvitationPage } from "src/pages/AcceptInvitationPage";

export const Route = createFileRoute("/_public/invitations/$invitationId/")({
  component: AcceptInvitationPage,
  ssr: true,
});
